// import Cookies from 'js-cookie'

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.accordion();
        this.checkStatus();
        this.hideBnr();
    }

    accordion() {
        const topAccArr = [...document.querySelectorAll(".js-top-acc")];

        topAccArr.forEach(topAcc => {
            const list = topAcc.querySelector(".js-top-acc_list");
            const btn = topAcc.querySelector(".js-top-acc_btn");
            const itemArr = [...list.querySelectorAll(".js-top-acc_list_item")];
            let prevWidth = 0;

            const initAcc = () => {
                if (prevWidth != window.innerWidth) {
                    topAcc.classList.remove("-active");
                    list.style.display = "grid";
                    list.style.height = `${getInitHeight()}px`;
                    list.style.transition = null;
                    prevWidth = window.innerWidth;
                }
            };

            const getInitHeight = () => {
                const loopNum = window.matchMedia("(min-width: 835px)").matches ? 1 : 5;
                const rowGap = parseInt(getComputedStyle(list).rowGap);
                let initHeight = 0;

                for (let i = 0; i < loopNum; i++) {
                    if (i % 2 == 0) {
                        initHeight += itemArr[i].clientHeight;
                        if (i > 0) initHeight += rowGap;
                    }
                }

                return initHeight;
            };

            window.addEventListener("load", initAcc);
            window.addEventListener("resize", initAcc);

            btn.addEventListener("click", () => {
                const height = topAcc.classList.contains("-active") ? getInitHeight() : list.scrollHeight;
                topAcc.classList.toggle("-active");
                list.style.height = `${height}px`;
                list.style.transition = "height 0.8s";
            });
        });
    }

    checkStatus() {
        // const status = Cookies.get('hideBnr');
        const aside = document.querySelector(".aside");

        // if (!status) {
        //     aside.classList.add("-show");
        // } else {
        //     aside.classList.add("-off");
        // }
        aside.classList.add("-show");
    }

    hideBnr() {
        const close = document.querySelector(".js-hidebnr");
        const aside = document.querySelector(".aside");

        close.addEventListener("click", () => {
            // Cookies.set('hideBnr', 1)
            aside.classList.add("-hide");
        });
    }
}
